module.exports = __webpack_public_path__ + "img/icon_support.1de6d273.svg";